import {
    CREATE_OR_UPDATE_CREDIT,
    CREATE_OR_UPDATE_CREDIT_START,
    GET_CREDIT_DETAILS,
    GET_CREDIT_DETAILS_START,
    TOGGLE_CREDIT_DETAILS,
    GET_PLANS,
    GET_PLANS_START,
    ATTACH_PLAN_TO_CLIENT,
    GET_EMAIL_PLANS,
    DELETE_CREDIT_START,
    DELETE_CREDIT,
    DETACH_PLAN_FROM_CLIENT,
    DELETE_PLANS_FROM_CLIENT, CONFIRM_3D_SECURE,
    GET_INVOICES_START,
    GET_INVOICES
} from "./BillingActions";

const INITIAL_STATE = {
    invoices: [],
    fetching: false,
    saving: false,
    fetchingInvoices: false,
    error: '',
    customer: {},
    needUpdate: false,
    openCreditDetails: false,
    invoicesContent: [],
    plansContent: [], //B
    emailPlans: [], //B
    defaultPlan: {}

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CREDIT_DETAILS_START:
            return { ...state, ...INITIAL_STATE, fetching: true };
        case GET_CREDIT_DETAILS:
            if (action.error || action.payload.response == undefined) {
                return { ...state, fetching: false, error: action.payload.message, customer: {}, needUpdate: false };
            }
            const { addressCity: city, addressCountry: country, zipCode: zip, addressState: region } = action.payload.response;
            return {
                ...state,
                fetching: false,
                needUpdate: false,
                customer: { ...action.payload.response, city, country, region, zip }
            };
        case TOGGLE_CREDIT_DETAILS:
            return { ...state, openCreditDetails: !state.openCreditDetails };
        case CREATE_OR_UPDATE_CREDIT_START:
            return { ...state, saving: true };
        case CREATE_OR_UPDATE_CREDIT:
            if (action.error) {
                return { ...state, saving: false, error: action.payload.message };
            }
            return { ...state, saving: false, needUpdate: true, openCreditDetails: false };

        // plans
        case GET_PLANS_START:
            return { ...state, ...INITIAL_STATE, fetching: true };
        case GET_PLANS:
            if (action.error) {
                return { ...state, fetching: false, error: action.payload.message, plansContent: {}, needUpdate: false };
            }
            return {
                ...state,
                fetching: false,
                needUpdate: false,
                plansContent: [...state.plansContent, ...action.payload.response.content],
                defaultPlan: action.payload.response.defaultPackage
            };

        case GET_INVOICES_START:
            return { ...state, ...INITIAL_STATE, fetching: true };
        case GET_INVOICES:
            if (action.error) {
                return { ...state, fetching: false, error: action.payload.message, invoicesContent: [], needUpdate: false };
            }
            return {
                ...state,
                fetching: false,
                needUpdate: false,
                invoicesContent: [...state.invoicesContent, ...action.payload.response]
            };

        case GET_EMAIL_PLANS:
            if (action.error) {
                return { ...state, fetching: false, error: action.payload.message, plansContent: {}, needUpdate: false };
            }
            return {
                ...state,
                fetching: false,
                needUpdate: false,
                emailPlans: [...state.emailPlans, ...action.payload.response]
            };
        case DELETE_CREDIT_START:
            return { ...state, deleting: true };
        case DELETE_CREDIT:
            if (action.error) {
                return { ...state, saving: false, needUpdate: true, error: action.payload.message };
            }
            return { ...state, deleting: false, needUpdate: true, openCreditDetails: false };

        case ATTACH_PLAN_TO_CLIENT:
            return { ...state, needUpdate: true};

        case DETACH_PLAN_FROM_CLIENT:
            return { ...state, needUpdate: true};

        case DELETE_PLANS_FROM_CLIENT:
            return { ...state, needUpdate: true};

        case CONFIRM_3D_SECURE:
            return { ...state, needUpdate: true };

    }
    return state;
};



// WEBPACK FOOTER //
// ./src/containers/billing/BillingReducer.js